import { Component } from '@angular/core';

interface RailItem { label: string; path: string; glyph: string; }

@Component({
  selector: 'app-money-manager',
  templateUrl: './money-manager.component.html',
  styleUrls: ['./money-manager.component.scss'],
  standalone: false,
})
export class MoneyManagerComponent {
  readonly items: RailItem[] = [
    { label: 'Dashboard',    path: 'dashboard',    glyph: '◧' },
    { label: 'Transactions', path: 'transactions', glyph: '☰' },
    { label: 'Categories',   path: 'categories',   glyph: '◎' },
    { label: 'Recurring',    path: 'recurring',    glyph: '↻' },
    { label: 'Accounts',     path: 'accounts',     glyph: '▤' },
    { label: 'Savings',      path: 'savings',      glyph: '↗' },
    { label: 'Reports',      path: 'reports',      glyph: '≡' },
    { label: 'Budgets',      path: 'budgets',      glyph: '◐' },
    { label: 'Mortgage',     path: 'mortgage',     glyph: '⌂' },
    { label: 'FIRE',         path: 'fire',         glyph: '△' },
    { label: 'Import CSV',   path: 'import',       glyph: '↑' },
  ];
}
